const PREFIX = "ACTIONS_BUTTONS_";
export const TOGGLE_WATCHLIST_ITEM = PREFIX + "TOGGLE_WATCHLIST_ITEM";
export const TOGGLE_COMPARE_LIST_ITEM = PREFIX + "TOGGLE_COMPARE_LIST_ITEM";
export const CLEAR_COMPARE_LIST = PREFIX + "CLEAR_COMPARE_LIST";

